import wixData from 'wix-data';
import wixAnimations from 'wix-animations';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';

let formFactor = wixWindow.formFactor;
let baseUrl = wixLocation.baseUrl;
let url = wixLocation.url;
let prefix = wixLocation.prefix;
let path = wixLocation.path;
// ...

$w.onReady(function () {
    onLoad()
});

function onLoad() {
    setLogosFilter()

}

////

function setLogosFilter() {
    if (url !== baseUrl) {
        $w("#boxButtonLogoIdeaDesktop").show()
    }

    let timeline = wixAnimations.timeline();
    const arrow = $w("#arrowMegaMenu");
    const arrowMobileIndustries = $w("#arrowMobileIndustries");
    const arrowMobileStyles = $w("#arrowMobileStyles");
    const arrowMobileColors = $w("#arrowMobileColors");

    function toggleArrow(angle, element) {
        timeline
            .add(element, {
                "rotate": angle,
                "duration": 200,
                "easing": "easeOutCubic"
            })
        timeline.play();
    }

    if (formFactor === "Mobile") {
        collapseAllRepeaterMobile()
    }

    $w("#buttonToggleMegaMenu").onClick((event) => {
        if ($w("#boxMegaMenu").isVisible) {
            $w("#boxMegaMenu").hide()
            toggleArrow(0, arrow)
            if (formFactor === "Mobile") {
                toggleArrow(0, arrowMobileIndustries)
                toggleArrow(0, arrowMobileStyles)
                toggleArrow(0, arrowMobileColors)
                collapseAllRepeaterMobile()
            }
        } else {
            $w("#sectionLogos").scrollTo()
            $w("#boxMegaMenu").show()
            toggleArrow(180, arrow)
        }
    });

    // MOBILE MENU ///

    $w("#buttonIndustriesMobile").onClick((event) => {
        if ($w("#repeaterIndustries").collapsed) {
            collapseAllRepeaterMobile()
            toggleArrow(0, arrowMobileStyles)
            toggleArrow(0, arrowMobileColors)
            $w("#repeaterIndustries").expand()
            toggleArrow(180, arrowMobileIndustries)
        } else {
            $w("#repeaterIndustries").collapse()
            toggleArrow(0, arrowMobileIndustries)
        }
    });

    $w("#buttonStylesMobile").onClick((event) => {
        if ($w("#repeaterStyles").collapsed) {
            collapseAllRepeaterMobile()
            toggleArrow(0, arrowMobileIndustries)
            toggleArrow(0, arrowMobileColors)
            $w("#repeaterStyles").expand()
            toggleArrow(180, arrowMobileStyles)
        } else {
            $w("#repeaterStyles").collapse()
            toggleArrow(0, arrowMobileStyles)
        }
    });

    $w("#buttonColorsMobile").onClick((event) => {
        if ($w("#repeaterColors").collapsed) {
            collapseAllRepeaterMobile()
            toggleArrow(0, arrowMobileIndustries)
            toggleArrow(0, arrowMobileStyles)
            $w("#repeaterColors").expand()
            toggleArrow(180, arrowMobileColors)
        } else {
            $w("#repeaterColors").collapse()
            toggleArrow(0, arrowMobileColors)
        }
    });

    function collapseAllRepeaterMobile() {
        $w("#repeaterIndustries").collapse()
        $w("#repeaterStyles").collapse()
        $w("#repeaterColors").collapse()
    }

    /// DATA ////
    let allLogos
    let allLogosIndustries
    let allLogosStyles
    let allLogosColors
    let categoryLabelString
    let categoryLabelStringFirstWord

    if (path[0] !== undefined) {
        const categoryLabel = path[0];
        let checkIfColorPage = categoryLabel.slice(categoryLabel.length - 12, categoryLabel.length);
        let firstWordIndexColor = 0
        let categoryLabelSplitNoDash = categoryLabel.replace(/-/g, " ");
        categoryLabelString = categoryLabelSplitNoDash.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());

        if (checkIfColorPage === "logo-designs") {
            for (let x = 0; x < categoryLabelString.length; x++) {
                if (categoryLabelString[x] === " ") {
                    if (firstWordIndexColor === 0) {
                        firstWordIndexColor = x
                    }
                }
            }
        }

        if (firstWordIndexColor !== 0) {
            categoryLabelStringFirstWord = categoryLabelString.slice(0, firstWordIndexColor);
        } else {
            categoryLabelStringFirstWord = categoryLabelString
        }
        $w("#buttonToggleMegaMenu").label = categoryLabelStringFirstWord
    }

    wixData.query("industries")
        .ascending("industries")
        .eq("displayInMenu", true)
        .find()
        .then((results) => {
            allLogosIndustries = results.items
            $w("#repeaterIndustries").data = allLogosIndustries
            $w("#repeaterIndustries").forEachItem(($item, itemData, index) => {
                $item("#buttonIndustries").label = itemData.industries
                if ($item("#buttonIndustries").label === categoryLabelString) {
                    $item("#buttonIndustries").disable()
                }
                let pageNameLowerCase = itemData.industries.toLowerCase();
                let pageNameLowerCaseDash = pageNameLowerCase.replace(/ /g, "-");
                $item("#buttonIndustries").target = "_self";
                $item("#buttonIndustries").link = baseUrl + "/category/" + pageNameLowerCaseDash
            });
        })
        .catch((err) => {
            let errorMsg = err;
        });

    wixData.query("styles")
        .ascending("style")
        .eq("displayInMenu", true)
        .find()
        .then((results) => {
            allLogosStyles = results.items
            $w("#repeaterStyles").data = allLogosStyles
            $w("#repeaterStyles").forEachItem(($item, itemData, index) => {
                $item("#buttonStyles").label = itemData.style
                if ($item("#buttonStyles").label === categoryLabelString) {
                    $item("#buttonStyles").disable()
                }
                let pageNameLowerCase = itemData.style.toLowerCase();
                let pageNameLowerCaseDash = pageNameLowerCase.replace(/ /g, "-");
                $item("#buttonStyles").target = "_self";
                $item("#buttonStyles").link = baseUrl + "/styles/" + pageNameLowerCaseDash
            });
        })
        .catch((err) => {
            let errorMsg = err;
        });

    wixData.query("colors")
        .ascending("sort")
        .eq("visibleOnTheMenu", true)
        .find()
        .then((results) => {
            allLogosColors = results.items
            $w("#repeaterColors").data = allLogosColors
            $w("#repeaterColors").forEachItem(($item, itemData, index) => {
                $item("#buttonColors").label = itemData.color
                if ($item("#buttonColors").label === categoryLabelStringFirstWord) {
                    $item("#buttonColors").disable()
                }
                let pageNameLowerCase = itemData.colorpathurl.toLowerCase();
                let pageNameLowerCaseDash = pageNameLowerCase.replace(/ /g, "-");
                $item("#buttonColors").target = "_self";
                $item("#buttonColors").link = baseUrl + "/colors/" + pageNameLowerCaseDash
                $item("#boxColorCode").style.backgroundColor = itemData.colorCode
                if (itemData.color === "White") {
                    $item("#boxColorCode").style.borderColor = "#9C9FA4"
                    $item("#boxColorCode").style.borderWidth = "1px"
                }
            });
        })
        .catch((err) => {
            let errorMsg = err;
        });

}